<template>
  <div id="app">
    <router-view
      @resetCrops="resetCrops"
      @updateTotals="updateTotals"
      @cropRemoved="removeCrop" />
  </div>
</template>
<script lang="ts">
export default {
  data () {
    return {
      inoculantFees: [0, 0.07, 0.15]
    }
  },
  methods: {
    isLegume (entry) {
      let cropClass = entry.crop['class'].toLowerCase()
      return cropClass.indexOf('legume') > -1
    },
    resetCrops () {
      this.$store.state.formData.selectedCrops = []
      this.updateTotals()
    },
    removeCrop (crop) {
      let selectedCrops = this.$store.state.formData.selectedCrops
      selectedCrops.forEach((entry, index) => {
        if (entry.crop === crop) {
          selectedCrops.splice(index, 1)
        }
      })
      this.$store.state.formData.selectedCrops = selectedCrops
      this.updateTotals()
    },
    getFormattedValue (value) {
      return Math.round(value * 100) / 100
    },
    getDiscountRate () {
      let rate = 0
      if (this.$store.state.formData.acres >= 100) {
        rate = 5
      }
      if (this.$store.state.formData.acres >= 160.1) {
        rate = 7
      }
      if (this.$store.state.formData.acres >= 250.1) {
        rate = 10
      }
      return rate
    },
    getBlendingFeeRate (totalLbs) {
      let rate = 0.07
      if (totalLbs >= 2501) {
        rate = 0.06
      }
      if (totalLbs >= 5000) {
        rate = 0.05
      }
      return rate
    },
    updateTotals () {
      let componentCost = 0
      let lbsPerAcre = 0
      let legumeLbs = 0
      this.$store.state.formData.selectedCrops.forEach((entry, index) => {
        // cost calculation: price per lb * lbs per acre
        componentCost += parseFloat(entry.crop['pricePerLb'].replace('$', '')) * parseFloat(entry.amount)
        // weight calculation: the entry's weight, determined when added to the mix
        lbsPerAcre += parseFloat(entry.amount)
        if (this.isLegume(entry)) {
          legumeLbs += parseFloat(entry.amount) // legume weight totalled separately to compute inoculant cost
        }
      })
      let inoculantCost = this.inoculantFees[this.$store.state.formData.inoculantOption] * legumeLbs
      let totalLbs = lbsPerAcre * this.$store.state.formData.acres
      this.$store.commit('updateTotalLbs', this.getFormattedValue(lbsPerAcre))
      this.$store.commit('updateComponentCost', this.getFormattedValue(componentCost))
      this.$store.commit('updateInoculantCost', this.getFormattedValue(inoculantCost))
      this.$store.commit('updateBlendingFee', this.getBlendingFeeRate(totalLbs) * totalLbs / this.$store.state.formData.acres)
      this.$store.commit('updateDiscountAmt', this.getDiscountRate())
    }
  }
}
</script>

<style lang="scss">
  @import "./styles/app.scss";
</style>
